import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_SNACK_BAR_DEFAULT_OPTIONS,
  MatSnackBarModule,
} from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NasModelModule } from '@sama/ng-app-state';
import { ButtonComponent } from '../shared/forms/basic-inputs/button/button.component';
import { CheckboxComponent } from '../shared/forms/basic-inputs/checkbox/checkbox.component';
import { InputComponent } from '../shared/forms/basic-inputs/input/input.component';
import { NumberInputComponent } from '../shared/forms/basic-inputs/number-input/number-input.component';
import { DisableWithTooltipHelperComponent } from '../shared/forms/helpers/disable-with-tooltip-helper.component';
import { HorizontalFormRowComponent } from '../shared/forms/horizontal-form/horizontal-form-row.component';
import { HorizontalFormComponent } from '../shared/forms/horizontal-form/horizontal-form.component';
import { AutocompleteChipsComponent } from '../shared/misc-components/autocomplete-chips-input.component';
import { ClickNSpinDirective } from '../shared/progress-utilities/click-n-spin.directive';
import { ButtonWithPopoverComponent } from './components/button-with-popover/button-with-popover.component';
import { ToggleButtonGroupComponent } from './components/toggle-button-group/toggle-button-group.component';
import { CustomIconDirective } from './icons/custom-icon.directive';
import { InjectorDirective } from './injector.directive';
import { DetailedMessageComponent } from './messaging/detailed-message/detailed-message.component';
import { ScrollDisablerDirective } from './scroll-disabler.directive';
import { ScrollEnablerDirective } from './scroll-enabler.directive';
import { ToolModeComponent } from './secondary-toolbar/tool-mode.component';
import { LayerViewSettingsPopoverComponent } from './toolbars/layer-settings/layer-view-settings-popover.component';
import { LayerViewSettingsComponent } from './toolbars/layer-settings/layer-view-settings.component';
import { ObjectlessViewSettingsOpacitySliderComponent } from './toolbars/view-settings/objectless-view-settings-opacity-slider.component';
import { ObjectlessViewSettingsSliderComponent } from './toolbars/view-settings/objectless-view-settings-slider.component';
import { HelpTooltipComponent } from './tooltips/help-tooltip.component';

const exportedItems = [
  ButtonComponent,
  ButtonWithPopoverComponent,
  CheckboxComponent,
  ClickNSpinDirective,
  DisableWithTooltipHelperComponent,
  HorizontalFormComponent,
  HorizontalFormRowComponent,
  InjectorDirective,
  InputComponent,
  LayerViewSettingsComponent,
  LayerViewSettingsPopoverComponent,
  NumberInputComponent,
  ToggleButtonGroupComponent,
  ToolModeComponent,
  ObjectlessViewSettingsOpacitySliderComponent,
  ObjectlessViewSettingsSliderComponent,
  ScrollDisablerDirective,
];

@NgModule({
  declarations: [exportedItems, DetailedMessageComponent],
  exports: [
    AutocompleteChipsComponent,
    exportedItems,
    CustomIconDirective,
    HelpTooltipComponent,
    MatIconModule,
    ScrollEnablerDirective,
  ],
  imports: [
    AutocompleteChipsComponent,
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    HelpTooltipComponent,
    MatButtonModule,
    MatButtonToggleModule,
    MatSnackBarModule,
    MatTooltipModule,
    NasModelModule,
    MatIconModule,
    MatRippleModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatFormFieldModule,
    OverlayModule,
    ReactiveFormsModule,
    PortalModule,
    ScrollEnablerDirective,
    CustomIconDirective,
  ],
  providers: [
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: { verticalPosition: 'bottom', horizontalPosition: 'left' },
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CrossTeamSharedModule {}
